"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectableCardSlots = exports.default = exports.SelectableCard = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _checkoutUtils = require("@ori/checkout-utils");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _ActionBanner = _interopRequireDefault(require("../ActionBanner"));
var _SelectButton = _interopRequireDefault(require("../SelectButton"));
var _selectableCardClasses = require("./selectableCardClasses");
var _jsxRuntime = require("react/jsx-runtime");
function showServiceButton(serviceButton) {
  if (serviceButton === undefined) {
    return false;
  }
  const {
    disabled,
    onClick,
    text
  } = serviceButton;
  if ((0, _checkoutUtils.stringEmptyToUndefined)(text) !== undefined) {
    return onClick !== undefined || disabled === true;
  }
  return false;
}
const getSelectableCardSlots = ownerState => {
  const {
    isHovering,
    selected
  } = ownerState;
  return {
    root: ['root', selected && 'selected'],
    content: ['content', selected && 'selected'],
    actionBanner: ['actionBanner'],
    actionSlot: ['actionSlot', selected && 'selected', isHovering && 'actionHover']
  };
};
exports.getSelectableCardSlots = getSelectableCardSlots;
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = getSelectableCardSlots(ownerState);
  const composedClasses = (0, _mui.unstable_composeClasses)(slots, _selectableCardClasses.getSelectableCardUtilityClass, classes);
  return {
    ...classes,
    ...composedClasses
  };
};
const SelectableCardRoot = (0, _mui.styled)('div', {
  name: 'SelectableCard',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.root, ownerState.selected && styles.selected],
  shouldForwardProp: prop => (0, _components.rootShouldForwardProp)(prop) || prop === 'classes'
})(({
  theme,
  ownerState
}) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  alignItems: 'start',
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: theme.shape.largeComponentRadius,
  overflow: 'hidden',
  background: theme.palette.common.white,
  color: theme.palette.text.primary,
  fontSize: theme.typography.body1.fontSize,
  ...(ownerState.selected && {
    border: `1px solid ${theme.palette.default.dark}`
  }),
  // not expected scenario but added for completeness
  ...(ownerState.disabled && {
    border: `1px solid ${theme.palette.grey[200]}`
  })
}));
const SelectableCardContent = (0, _mui.styled)('div', {
  name: 'SelectableCard',
  slot: 'Content',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.content, ownerState.selected && styles.selected],
  shouldForwardProp: prop => (0, _components.rootShouldForwardProp)(prop) || prop === 'classes'
})(({
  theme,
  ownerState
}) => ({
  display: 'grid',
  justifySelf: 'stretch',
  alignItems: 'center',
  justifyItems: 'start',
  justifyContent: 'stretch',
  padding: theme.spacing(4, 3),
  overflow: 'hidden',
  background: theme.palette.common.white,
  color: theme.palette.text.primary,
  fontSize: theme.typography.body1.fontSize,
  textAlign: 'left',
  border: 'none',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4, 6)
  },
  ...(ownerState.selected && {
    background: theme.palette.grey[100]
  })
}));
const SelectableCardActionBanner = (0, _mui.styled)(_ActionBanner.default, {
  name: 'SelectableCard',
  slot: 'ActionBanner',
  overridesResolver: (_, styles) => [styles.actionBanner],
  shouldForwardProp: prop => (0, _components.rootShouldForwardProp)(prop) || prop === 'classes'
})(({
  theme
}) => ({
  borderRadius: `0 0 ${theme.shape.largeComponentRadius}px ${theme.shape.largeComponentRadius}px`,
  padding: theme.spacing(3, 3),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3, 6)
  }
}));
const SelectableCardActions = (0, _mui.styled)('div', {
  name: 'SelectableCard',
  slot: 'ActionSlot',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.actionSlot, ownerState.selected && styles.selected, ownerState.isHovering && styles.actionHover],
  shouldForwardProp: prop => (0, _components.rootShouldForwardProp)(prop) || prop === 'classes'
})(({
  theme,
  ownerState
}) => ({
  justifySelf: 'stretch',
  display: 'grid',
  gap: theme.spacing(3),
  padding: theme.spacing(0, 3, 4),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(0, 6, 4)
  },
  transition: theme.transitions.create(['background-color', 'color'], {
    duration: theme.transitions.duration.short
  }),
  ...(ownerState.isHovering && {
    background: theme.palette.grey[100],
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }),
  ...(ownerState.selected && {
    background: theme.palette.grey[100]
  }),
  ...(ownerState.disabled && {
    background: theme.palette.common.white
  })
}));
const EditDeleteHolder = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  gridTemplateColumns: 'auto auto',
  gap: theme.spacing(3),
  justifyItems: 'start',
  justifyContent: 'start'
}));
const SelectableCard = exports.SelectableCard = /*#__PURE__*/(0, _react.forwardRef)((inProps, ref) => {
  const props = (0, _mui.useThemeProps)({
    props: inProps,
    name: 'SelectableCard'
  });
  const {
    ActionBannerComponentProps,
    AlertComponentProps,
    ButtonComponentProps,
    children,
    className,
    testId,
    deleteButton = undefined,
    disabled = false,
    editButton = undefined,
    indicator = 'radio',
    loading = false,
    logger,
    onClick,
    selected = false,
    ...other
  } = props;
  const [isHovering, setIsHovering] = (0, _react.useState)(false);
  const handleMouseOver = (0, _react.useCallback)(() => {
    setIsHovering(true);
  }, []);
  const handleMouseOut = (0, _react.useCallback)(() => {
    setIsHovering(false);
  }, []);
  const actionBannerSlotProps = (0, _react.useMemo)(() => {
    if (ActionBannerComponentProps?.children === undefined) {
      return undefined;
    }
    if (ActionBannerComponentProps.onClick === undefined && ActionBannerComponentProps.href === undefined) {
      return undefined;
    }
    const {
      iconName = 'TruckFilled',
      dataTestId,
      showBorder,
      style,
      sx,
      ...rest
    } = ActionBannerComponentProps;
    let innerDataTestId = dataTestId;
    if (dataTestId === undefined && testId !== undefined) {
      innerDataTestId = `${testId}-action-banner`;
    }
    return {
      ...rest,
      dataTestId: innerDataTestId,
      iconName
    };
  }, [ActionBannerComponentProps, testId]);
  const showActionBanner = typeof actionBannerSlotProps !== 'undefined';
  const alertProps = (0, _react.useMemo)(() => {
    if (AlertComponentProps?.children === undefined) {
      return undefined;
    }
    const innerDataTestId = testId !== undefined ? `${testId}-alert` : undefined;
    return {
      severity: 'warning',
      variant: 'standard',
      'data-testid': innerDataTestId,
      ...AlertComponentProps
    };
  }, [AlertComponentProps, testId]);
  const showAlert = typeof alertProps !== 'undefined';
  const ownerState = (0, _react.useMemo)(() => ({
    ...props,
    disabled,
    selected,
    isHovering
  }), [props, disabled, selected, isHovering]);
  const classes = useUtilityClasses(ownerState);
  const selectButtonProps = (0, _react.useMemo)(() => {
    // if indicator is none then it is not a selectable element but just info element
    if (indicator === 'none') {
      return undefined;
    }
    let innerDataTestId = ButtonComponentProps?.dataTestId;
    if (ButtonComponentProps?.dataTestId === undefined && testId !== undefined) {
      innerDataTestId = `${testId}-main-action`;
    }

    // if the item is selected and indicator is radio then we are not process click
    // same if onClick is not provided
    if (selected && indicator === 'radio' || onClick === undefined) {
      return {
        ...ButtonComponentProps,
        selected,
        disabled,
        indicator,
        dataTestId: innerDataTestId,
        onClick: undefined,
        disableRipple: true,
        disableTouchRipple: true,
        tabIndex: -1
      };
    }
    return {
      ...ButtonComponentProps,
      dataTestId: innerDataTestId,
      selected,
      disabled,
      indicator,
      onClick
    };
  }, [ButtonComponentProps, testId, selected, disabled, indicator, onClick]);
  const showSelectButton = typeof selectButtonProps !== 'undefined';

  // handling edit delete button area
  const showEditButton = showServiceButton(editButton);
  const showDeleteButton = showServiceButton(deleteButton);
  const showEditDelete = showEditButton || showDeleteButton;
  const editButtonProps = (0, _react.useMemo)(() => {
    if (editButton === undefined) {
      return {
        variant: 'text',
        size: 'small'
      };
    }
    const {
      text,
      dataTestId,
      ...rest
    } = editButton;
    let innerDataTestId = dataTestId;
    if (dataTestId === undefined && testId !== undefined) {
      innerDataTestId = `${testId}-edit-button`;
    }
    return {
      ...rest,
      children: text,
      'data-testid': innerDataTestId,
      variant: 'text',
      size: 'small'
    };
  }, [editButton, testId]);
  const deleteButtonProps = (0, _react.useMemo)(() => {
    if (deleteButton === undefined) {
      return {
        variant: 'text',
        size: 'small'
      };
    }
    const {
      text,
      dataTestId,
      ...rest
    } = deleteButton;
    let innerDataTestId = dataTestId;
    if (dataTestId === undefined && testId !== undefined) {
      innerDataTestId = `${testId}-delete-button`;
    }
    return {
      ...rest,
      children: text,
      'data-testid': innerDataTestId,
      variant: 'text',
      size: 'small'
    };
  }, [deleteButton, testId]);
  const contentTestId = testId === undefined ? undefined : `${testId}-content`;
  if (loading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
      height: 66,
      variant: "rounded",
      width: "100%",
      "data-testid": `loading-${testId ?? 'selectable-card'}`,
      ...other
    });
  }
  if (children === undefined) {
    const error = new Error('SelectableCard must have children.');
    if (logger) {
      logger.error(error);
    } else {
      throw error;
    }
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(SelectableCardRoot, {
    ref: ref,
    className: (0, _clsx.default)(classes.root, className),
    "data-testid": testId,
    ownerState: ownerState,
    ...other,
    children: [showSelectButton ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectButton.default, {
      ...selectButtonProps,
      onMouseOver: handleMouseOver,
      onMouseOut: handleMouseOut,
      children: children
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectableCardContent, {
      "data-testid": contentTestId,
      ownerState: ownerState,
      children: children
    }), showAlert || showEditDelete ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(SelectableCardActions, {
      ownerState: ownerState,
      className: (0, _clsx.default)(classes.actionSlot, isHovering && classes.actionHover),
      children: [showAlert ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Alert, {
        ...alertProps
      }) : null, showEditDelete ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(EditDeleteHolder, {
        children: [showEditButton ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
          ...editButtonProps,
          children: editButtonProps.children
        }) : null, showDeleteButton ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
          ...deleteButtonProps,
          children: deleteButtonProps.children
        }) : null]
      }) : null]
    }) : null, showActionBanner ? /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectableCardActionBanner, {
      ...actionBannerSlotProps,
      className: classes.actionBanner
    }) : null]
  });
});
var _default = exports.default = SelectableCard;